import React, { useState, useEffect, useContext } from "react";
import {
  createProduct,
  updateProduct,
  getCategory,
  getSubCategory,
  apiClient,
  getSuppliers,
  getcategorybasesubcategory,
  getWarehouses,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import { WarehouseContext } from '../../../Utility/UserContext';
import { warehouse_id } from "../../../Utility/function";

const ProductForm = ({ selectedProduct, closeModal, refreshList }) => {
  const ware_data = warehouse_id;
  const [formData, setFormData] = useState({
    product_name: "",
    cat_id: "",
    subcat_id: "",
    supplier_id: "",
    descriptions: "",
    product_image: "",
    warehouse_id: ware_data,
    status: "1",
  });
  const { showLoader, hideLoader } = useContext(WarehouseContext);

  const [category, setCategory] = useState([]);
  const [subcategory, setSubCategory] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [filteredSubcategories, setFilteredSubcategories] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [errors, setErrors] = useState({})

  useEffect(() => {
    fetchCategory();
    fetchSubCategory();
    fetchSuppliers();
    if (selectedProduct?.product_name) {
      setFormData({
        product_name: selectedProduct?.product_name,
        cat_id: selectedProduct?.category_id,
        subcat_id: selectedProduct?.subcategory_id,
        supplier_id: selectedProduct?.supplier_id,
        descriptions: selectedProduct?.descriptions,
        product_image: selectedProduct?.product_image,
        status: selectedProduct?.status?.toString(),
      });

      filterSubcategories1(selectedProduct?.category_id);
    } else if (selectedProduct?.warehouse_id) {

      setFormData({
        warehouse_id: selectedProduct?.warehouse_id
      })
    }

  }, [selectedProduct]);

  const fetchCategory = async () => {
    try {
      const response = await getCategory();
      if (response.data && response.data.data) {
        const cate = response.data.data
        setCategory(cate.filter(cat => cat.status == null || cat.status == 0));
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };

  const fetchSubCategory = async () => {
    try {
      const response = await getSubCategory();
      if (response.data && response.data.data) {
        setSubCategory(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching subcategory data:", error);
    }
  };

  // const fetchWarehouse = async () => {
  //   try {
  //     const response = await getWarehouses();
  //     if (response.data && response.data.data) {
  //       setWarehouses(response.data.data);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching warehouse data:', error);
  //     toast.error('Error fetching warehouses');
  //   }
  // };

  const fetchSuppliers = async () => {
    try {
      const response = await getSuppliers();
      if (response.data && response.data.data) {
        setSupplier(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching suppliers data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "cat_id") {
      filterSubcategories1(value);
    }
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const filterSubcategories1 = async (categoryId) => {
    try {
      const response = await getcategorybasesubcategory(categoryId);
      if (response.data && response.data.data) {
        console.log("response", response.data);
        // const Filterdate = response.data.data;
        // setFilteredSubcategories(Filterdate);
        const cate = response.data.data
        setFilteredSubcategories(cate.filter(cat => cat.status == null || cat.status == 0));
      }
    } catch (error) {
      console.error("Error fetching suppliers data:", error);
    }
  };

  const handleSubmit = async (e) => {
    showLoader()
    e.preventDefault();
    const validationErrors = {};

    // if (!formData.cat_id) {
    //   validationErrors.cat_id = "category title is required.";  
    // }
    // if (!formData.subcat_id) {
    //   validationErrors.subcat_id = "subcategory title is required.";  
    // }
    if(!formData.product_name) {
      validationErrors.product_name = "product name is required.";
    }
    if (Object.keys(validationErrors).length > 0) {
      hideLoader()
      setErrors(validationErrors);
      return;
    }

    const payload = {
      product: formData
      
    }
    try {
      if (selectedProduct?.product_id) {
        await updateProduct(selectedProduct?.product_id, payload);
        hideLoader()
        toast.success("Product updated successfully");
      } else {
        await createProduct(payload);
        hideLoader()
        toast.success("Product added successfully");
      }
      closeModal();
      refreshList();
    } catch (error) {
      console.error("Error saving product data:", error);
      hideLoader()
      if (error.response && error.response.data) {
        toast.error(error.response.data.message || "Error saving product");
      } else {
        toast.error("Error saving product");
      }
    }
  };

  const [searchCustomerTerm, setSearchCustomerTerm] = useState();
  const filteredCustomers = searchCustomerTerm
    ? category.filter((item) =>
      item.Categories.toLowerCase().includes(searchCustomerTerm.toLowerCase())
    )
    : category;
  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title">
              {selectedProduct?.product_id ? "Edit Product" : "Add Product"}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body" style={{ fontFamily: "poppins" }}>
            <form onSubmit={handleSubmit} encType="multipart/form-data">

              <div className="form-group mb-3 d-flex align-items-center">
                <label className="col-4 text-normal">Category</label>
                <div className="col-8">
                  <select
                    name="cat_id"
                    value={formData.cat_id}
                    onChange={handleChange}
                    className="form-control text-normal"
                  >
                    <option value="">Select Category</option>
                    {category.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.Categories}
                      </option>
                    ))}
                  </select>
                  {errors.cat_id && (
                    <small className="text-danger">{errors.cat_id}</small>
                  )}
                </div>
              </div>
              
              <div className="form-group mb-3 d-flex align-items-center">
                <label className="col-4 text-normal">Category</label>
                <div className="dropdown col-8">
                  <input
                    className="w-50"
                    type="text"
                    placeholder="Search Customer"
                    value={searchCustomerTerm}
                    onChange={(e) => setSearchCustomerTerm(e.target.value)}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  />
                  <ul className="dropdown-menu w-50" style={{ maxHeight: '300px', overflowY: 'scroll' }} aria-labelledby="dropdownMenuButton">
                    {filteredCustomers.map((item) => (
                      <li key={item.id}>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            if (item.id) {
                              filterSubcategories1(item.id);
                              setSearchCustomerTerm(item.Categories)
                              setFormData({
                                ...formData,
                                ["cat_id"]: item.id,
                              });
                            }
                          }}
                        >
                          {item.Categories}
                        </a>
                      </li>
                    ))}
                  </ul>

                </div>

              </div>

              <div className="form-group mb-3 d-flex align-items-center">
                <label className="col-4 text-normal">SubCategory</label>
                <div className="col-8">
                  <select
                    name="subcat_id"
                    value={formData.subcat_id}
                    onChange={handleChange}
                    className="form-control text-normal"

                  >
                    <option value="">Select SubCategory</option>
                    {filteredSubcategories.map((subcat) => (
                      <option
                        key={subcat.subcategory_id}
                        value={subcat.subcategory_id}
                      >
                        {subcat.subcategory_name}
                      </option>
                    ))}
                  </select>
                  {errors.subcat_id && (
                    <small className="text-danger">{errors.subcat_id}</small>
                  )}
                </div>
              </div>
              <div className="form-group mb-3 d-flex align-items-center">
                <label className="col-4 text-normal">Product Name</label>
                <div className="col-8">
                  <input
                    type="text"
                    name="product_name"
                    value={formData.product_name}
                    onChange={handleChange}
                    className="form-control text-normal"

                  />
                  {errors.product_name && (
                    <small className="text-danger">{errors.product_name}</small>
                  )}
                </div>
              </div>
              <div className="form-group mb-3 d-flex align-items-center">
                <label className="col-4 text-normal">Description</label>
                <textarea
                  type="text"
                  name="descriptions"
                  value={formData.descriptions}
                  onChange={handleChange}
                  className="form-control text-normal"

                />
              </div>
              {/* <div className="form-group mb-3 d-flex align-items-center">
                <label className="col-4 text-normal">Image</label>
                <input
                  type="file"
                  name="product_image"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      product_image: e.target.files[0],
                    })
                  }
                  className="form-control text-normal"
                />
              </div> */}
              {selectedProduct?.product_id && (
                <div className="form-group mb-3 d-flex align-items-center">
                  <label className="col-4 text-normal">Status</label>
                  <select
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                    className="form-control text-normal"

                  >
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
              )}

              <div className="mt-5">
                <button type="submit" className="btn btn-success float-end text-normal rounded-1">
                  {selectedProduct?.product_id ? "Update Product" : "Add Product"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary ml-2 float-end me-1 text-normal rounded-1"
                  onClick={closeModal}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductForm;
